import { render, staticRenderFns } from "./FormProjectrecipesTable.vue?vue&type=template&id=0d19b31e&"
import script from "./FormProjectrecipesTable.vue?vue&type=script&lang=js&"
export * from "./FormProjectrecipesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormProjectrecipesTable.vue"
export default component.exports